import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({  breakpoints,variables, palette }) => ({
  '@keyframes pulsate':{
    '0%': {
        transform:'scale(1)'
    },
    '50%': {
        transform: 'scale(1.3)'
    },
    '100%': {
        transform: 'scale(1)'
    }
},
  welcomingContent: {
    width: '820px',
    [breakpoints.down('sm')]:{
      width:'100%',
    },
    [breakpoints.down('xs')]:{
      width:'100%',
      paddingLeft:variables?.spacingF,
      paddingRight:variables?.spacingF,
    },
    margin: '0 auto',
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      [breakpoints.down('xs')]: {
        display:'block',
        float:'left',
        height:'50px',
        marginRight:variables?.spacingB
      }
    },
    '& .icons-holder': {
      width:'232px',
      height:'46px',
      display: 'flex',
      justifyContent: 'center',
      marginLeft:'auto',
      marginRight:'auto',
      position:'relative',
      marginTop: variables?.spacingD,
      marginBottom: variables?.spacingD,
      [breakpoints.down('xs')]: {
        marginBottom:variables?.spacingF
      },
      '& .heart-image': {
        position:'absolute',
        animation: '$pulsate 1s infinite',
        left:'calc(50% - 17px)'
      }
    },
    '& .welcoming-section-content-title':{ 
      [breakpoints.down('xs')]: {
        marginBottom:variables?.spacingF
      }
    },
    '& .welcoming-description': {
      width: '673px',
      [breakpoints.down('xs')]: {
        width:'100%'
      },
      display: 'block',
      margin: '0 auto',
    },
  }
}));

export default useStyles;
